import React, { useState, useEffect } from 'react';
import './About.css';
import { getAboutSettings } from '../firebase/dataService';

function About() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const data = await getAboutSettings();
      setSettings(data);
    } catch (error) {
      console.error('Error loading about settings:', error);
      setSettings(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="about-page">
        <div className="loading-container">
          <div className="loader"></div>
          <p>جاري التحميل...</p>
        </div>
      </div>
    );
  }

  if (!settings || !settings.visible) {
    return (
      <div className="about-page">
        <div className="about-container">
          <div className="about-header">
            <h1 className="about-title">⚠️ الصفحة غير متاحة</h1>
            <div className="title-divider"></div>
            <p className="about-subtitle">عذراً، هذه الصفحة غير متاحة حالياً</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-header">
          <h1 className="about-title">{settings.pageTitle || 'عن الشيخ'}</h1>
          <div className="title-divider"></div>
        </div>

        <div className="about-content">
          {settings.profile?.enabled !== false && (
          <div className="about-section">
            <div className="section-icon">👤</div>
            <h2 className="section-title">{settings.profile?.name || 'سلمان بن عبدالله الحران'}</h2>
            <p className="section-text">
              {settings.profile?.description || 'طالب علم متخصص في العلوم الشرعية'}
            </p>
          </div>
          )}

          {settings.series?.enabled !== false && (
          <div className="about-section">
            <div className="section-icon">📚</div>
            <h2 className="section-title">{settings.series?.title || 'سلسلة الفوائد'}</h2>
            <p className="section-text">
              {settings.series?.description || 'سلسلة تعليمية دينية'}
            </p>
          </div>
          )}

          {settings.goals?.enabled !== false && settings.goals?.items?.length > 0 && (
          <div className="about-section">
            <div className="section-icon">🎯</div>
            <h2 className="section-title">{settings.goals?.title || 'الأهداف'}</h2>
            <ul className="goals-list">
              {settings.goals.items.map((goal, index) => (
                <li key={index}>{goal}</li>
              ))}
            </ul>
          </div>
          )}

          {settings.topics?.enabled !== false && settings.topics?.items?.length > 0 && (
          <div className="about-section">
            <div className="section-icon">📖</div>
            <h2 className="section-title">{settings.topics?.title || 'المجالات'}</h2>
            <div className="topics-grid">
              {settings.topics.items.map((topic, index) => (
                <div key={index} className="topic-item">{topic}</div>
              ))}
            </div>
          </div>
          )}

          {settings.contact?.enabled !== false && (
          <div className="about-section contact-section">
            <div className="section-icon">📧</div>
            <h2 className="section-title">{settings.contact?.title || 'تواصل معنا'}</h2>
            <div className="contact-links">
              {settings.contact?.twitter && (
              <a href={settings.contact.twitter} target="_blank" rel="noopener noreferrer" className="contact-btn">
                <span>🐦</span>
                <span>Twitter</span>
              </a>
              )}
              {settings.contact?.youtube && (
              <a href={settings.contact.youtube} target="_blank" rel="noopener noreferrer" className="contact-btn youtube-btn">
                <span>📺</span>
                <span>YouTube</span>
              </a>
              )}
              {settings.contact?.telegram && (
              <a href={settings.contact.telegram} target="_blank" rel="noopener noreferrer" className="contact-btn">
                <span>✈️</span>
                <span>Telegram</span>
              </a>
              )}
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default About;
